import API from "./axios";

const authApi = {
  login: (username, password) =>
    API.post("/auth/login", { username, password }),

  logout: () =>
    API.post("/auth/logout"),

  me: () =>
    API.get("/auth/me"),

  forgotPassword: (username) =>
    API.post("/auth/forgot-password", { username }),

  resetPassword: (token, newPassword) =>
    API.post("/auth/reset-password", { token, newPassword }),
};

export default authApi;
